import {
  HttpClient,
  provideHttpClient,
  withInterceptors
} from '@angular/common/http';
import {
  ErrorHandler,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withComponentInputBinding,
  withInMemoryScrolling,
  withViewTransitions
} from '@angular/router';
import {
  MissingTranslationHandler,
  provideTranslateService,
  TranslateLoader
} from '@ngx-translate/core';
import { AuthHttpService } from '@shared/data';
import { MissingTranslationHelper, SentryErrorHandler } from '@shared/handlers';
import { authInterceptor } from '@shared/interceptors';
import { AppInitializeService } from '@shared/services';
import { getPreferredLanguage } from '@shared/utils';
import { en_GB, provideNzI18n } from 'ng-zorro-antd/i18n';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { translationHttpLoaderFactory } from '@shared/factories';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideNzI18n(en_GB),
    importProvidersFrom(BrowserModule),
    provideTranslateService({
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: MissingTranslationHelper
      },
      loader: {
        provide: TranslateLoader,
        useFactory: translationHttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled'
      }),
      withViewTransitions()
    ),
    AuthHttpService,
    provideHttpClient(withInterceptors([authInterceptor])),
    {
      provide: ErrorHandler,
      useClass: SentryErrorHandler
    },
    provideAppInitializer(() => inject(AppInitializeService).init()),
    {
      provide: LOCALE_ID,
      useFactory: getPreferredLanguage
    },
    provideAnimationsAsync()
  ]
}).catch(err => console.error('Angular Bootstrap Error:', err));
